const CallButtonsContainerStyle = `
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-column-gap: 25px;
  justify-content: center;
  margin-bottom: 10px;
`;

export default CallButtonsContainerStyle;
